/* eslint-disable react/no-danger */
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import {
  Modal,
  ButtonToolbar,
  Button,
  ModalHeader,
  ModalBody,
  Spinner,
} from 'reactstrap';
import ApiClient from 'ApiClient';


const TranscriptTextModal = ({ record, showTranscriptText, setShowTranscriptText }) => {
  const [transcript, setTranscript] = useState('');
  const [loading, setLoading] = useState(true);
  useEffect(async () => {
    const mediaContentId = record.params?._id;
    if (showTranscriptText && mediaContentId) {
      setLoading(true);
      const api = new ApiClient();
      const response = await api.client.get(`/api/portal/scorecard/media-content/get-transcription?mediaContentId=${mediaContentId}`);
      setTranscript(response.data.transcription || '');
      setLoading(false);
    }
  }, [showTranscriptText, record]);

  return (
    <Modal
      isOpen={showTranscriptText}
      toggle={() => { setShowTranscriptText(false); }}
    >
      <ModalHeader
        toggle={() => { setShowTranscriptText(false); }}
        tag="h4"
        className="modal-title-statistics"
      >
        Transcript
      </ModalHeader>
      <ModalBody>
        {loading ? (
          <div className="text-center">
            <Spinner
              color="primary"
              size="lg"
            />
          </div>) : (
            <div
              style={{ maxHeight: '400px', overflowY: 'auto' }}
              dangerouslySetInnerHTML={{ __html: transcript !== 'null' ? transcript : '' }}
            />
          )
        }
      </ModalBody>
      <ButtonToolbar className="modal__footer">
        <Button className="btn btn-sm" color="secondary" onClick={() => { setShowTranscriptText(false); }}>Close</Button>
      </ButtonToolbar>
    </Modal>
  );
};

TranscriptTextModal.propTypes = {
  record: PropTypes.objectOf(PropTypes.any).isRequired,
  showTranscriptText: PropTypes.bool.isRequired,
  setShowTranscriptText: PropTypes.func.isRequired,
};
export default TranscriptTextModal;
